import {type FormSchema} from '@/features/company-registration/form';

// 前後の空白をtrimする
export function trimFormSchema(data: FormSchema): FormSchema {
  // 会社情報のデータをtrim
  const companyInfo: Record<string, string> = {};
  const companyInfoKeys = Object.keys(data.companyInfo) as Array<
    keyof FormSchema['companyInfo']
  >;
  for (const key of companyInfoKeys) {
    const value = data.companyInfo[key];
    if (typeof value === 'string') {
      companyInfo[key] = value.trim();
    }
  }

  // 担当者情報のデータをtrim
  const contactPerson: Record<string, string> = {};
  const contactPersonInfoKeys = Object.keys(data.contactPersonInfo) as Array<
    keyof FormSchema['contactPersonInfo']
  >;
  for (const key of contactPersonInfoKeys) {
    const value = data.contactPersonInfo[key];
    if (typeof value === 'string') {
      contactPerson[key] = value.trim();
    }
  }

  // 請求情報のデータをtrim
  const billingInfo: Record<string, string> = {};
  const billingInfoKeys = Object.keys(data.billingInfo) as Array<
    keyof FormSchema['billingInfo']
  >;
  for (const key of billingInfoKeys) {
    const value = data.billingInfo[key];
    if (typeof value === 'string') {
      billingInfo[key] = value.trim();
    }
  }

  return {
    ...data,
    companyInfo: {...data.companyInfo, ...companyInfo},
    contactPersonInfo: {...data.contactPersonInfo, ...contactPerson},
    billingInfo: {...data.billingInfo, ...billingInfo},
  };
}
